import type { Workflow } from '@compass/client/types/workflow';
import { useStore } from '@store/index';

/**
 * The workflow a case belongs to, read by the case's own `workflow_id`.
 *
 * Case pages must not use the global selection (`getSelectedWorkflow()`): the
 * workflows loader can move it to another workflow of the program after the case
 * syncs it, and a page that resolves its actions from that workflow sends another
 * workflow's actions (LA-8169: a PA Status PBM case sent a PA Status MedBV action,
 * which the server read as "approved" and completed the case). Falls back to the
 * global selection only until the case has loaded.
 */
export const useCaseWorkflow = (caseWorkflowId: string | undefined): Workflow | null => {
  const workflows = useStore(state => state.workflows);
  const getSelectedWorkflow = useStore(state => state.getSelectedWorkflow);

  if (caseWorkflowId) {
    return workflows[caseWorkflowId] ?? null;
  }
  return getSelectedWorkflow();
};
